@let agents = agents$ | async;

<main class="agpr-agentManagement" [agprLoading]="!agents">
    @if (agents) {
        @if (agents.length) {
            <section class="agpr-agentManagement-content" [attr.aria-label]="'Common.layout.main' | localize">
                <header class="agpr-agentManagement-header">
                    <span class="fa-kit-duotone fa-agpr-ai-generic agpr-agentManagement-headerIcon" aria-hidden="true"></span>
                    <h1 class="agpr-agentManagement-headerTitle">{{ 'AutomationAgents.heading' | localize }}</h1>
                </header>

                <!-- A spent pool puts every agent on the account into standby, so it is called out
                     above the list rather than per card -->
                @if (quotaExceeded$ | async) {
                    <agpr-message
                        id="agentManagement.quotaExceeded"
                        class="agpr-agentManagement-quotaBanner"
                        [severity]="messageSeverity.error"
                    >
                        {{ 'AutomationAgents.quotaExceeded' | localize }}
                    </agpr-message>
                }

                <div class="agpr-agentManagement-tabRow">
                    <agpr-tabs
                        class="agpr-agentManagement-tabs"
                        [selectedTabIndex]="0"
                        [useContentContainer]="false"
                    >
                        <agpr-tab
                            id="agentManagement_curationTab"
                            heading="AutomationAgents.tab.curation"
                        ></agpr-tab>
                    </agpr-tabs>

                    <!-- Two part control, as in agpr-mentions-sort-order: the left half flips the
                         direction, the caret opens the list of fields -->
                    <div
                        class="agpr-agentManagement-sort"
                        (clickOutside)="closeSortMenu()"
                        [attachOutsideOnClick]="true"
                    >
                        <div class="agpr-agentManagement-sortButtons">
                            <button
                                pButton
                                id="agentManagement.sortOrder"
                                class="agpr-agentManagement-sortOrderButton"
                                [icon]="sortOrderIcon"
                                [attr.aria-label]="sortLabels[sortField] | localize"
                                agprTooltip="AutomationAgents.list.sort.order"
                                tooltipPosition="top"
                                (click)="toggleSortOrder()"
                            ></button>
                            <button
                                pButton
                                id="agentManagement.sortMenu"
                                class="agpr-agentManagement-sortMenuButton"
                                icon="fa-solid fa-angle-down"
                                [attr.aria-expanded]="sortMenuVisible"
                                aria-controls="agentManagement-sort-listbox"
                                [attr.aria-label]="'AutomationAgents.list.sort' | localize"
                                agprTooltip="AutomationAgents.list.sort"
                                tooltipPosition="top"
                                (click)="toggleSortMenu()"
                            ></button>
                        </div>

                        @if (sortMenuVisible) {
                            <ul
                                role="listbox"
                                id="agentManagement-sort-listbox"
                                class="agpr-agentManagement-sortMenuItems"
                                agprListKeyboardNavigation
                            >
                                @for (field of sortFields; track field) {
                                    <li
                                        role="option"
                                        class="agpr-agentManagement-sortMenuItem"
                                        [ngClass]="{'agpr-agentManagement-sortMenuItem--selected': field === sortField}"
                                        [attr.aria-selected]="field === sortField"
                                        tabindex="-1"
                                        (click)="selectSortField(field)"
                                    >{{ sortLabels[field] | localize }}</li>
                                }
                            </ul>
                        }
                    </div>
                </div>

                <div class="agpr-agentManagement-center">
                    <agpr-scroll-panel class="agpr-agentManagement-listContainer">
                        <h2 class="u-srOnly">{{ 'AutomationAgents.list.heading' | localize }}</h2>
                        <ul class="agpr-agentManagement-list">
                            @for (agent of agents; track agent.id) {
                                <li class="agpr-agentManagement-listItem">
                                    <agpr-agent-card
                                        [agprLoading]="expandedAgentIds.has(agent.id) && !detailsLoadedAgentIds.has(agent.id)"
                                        [loadingSmallIndicator]="true"
                                        [agent]="agent"
                                        [expanded]="isExpanded(agent)"
                                        (expandedChange)="toggleExpanded(agent, $event)"
                                        (edited)="editAgent($event)"
                                        (deleted)="deleteAgent($event)"
                                        (viewed)="viewAgent($event)"
                                        (sourceToggled)="toggleSource(agent, $event)"
                                        (sourceViewed)="viewSource($event)"
                                        (sourceRemoved)="removeSource(agent, $event)"
                                    ></agpr-agent-card>
                                </li>
                            }
                        </ul>
                    </agpr-scroll-panel>

                    <agpr-action-bar [headingContext]="'AutomationAgents.heading' | localize">
                        <ng-template #right>
                            <agpr-button
                                id="agentManagement.create"
                                label="AutomationAgents.list.createAgent"
                                [style]="buttonTypes.primaryB"
                                (click)="createAgent()"
                            ></agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </div>
            </section>

            <aside class="agpr-agentManagement-usage" [attr.aria-label]="'Common.layout.rhp' | localize">
                <agpr-agent-usage-dashboard
                    [selectedPeriod]="usagePeriod"
                    (periodSelected)="usagePeriod = $event"
                    (expanded)="openUsageDialog()"
                ></agpr-agent-usage-dashboard>
            </aside>
        } @else {
            <agpr-hype></agpr-hype>
        }
    }
</main>
